
export default [
    {
        path: 'application',
        component: resolve => require(['@/views/application'], resolve),
        name: 'Application',
        keepAlive: true,
        meta: {
            nav: '产品及应用'
        }
    },
    {
        path: 'info',
        component: resolve => require(['@/views/application/info'], resolve),
        name: 'Info',
        meta: {
            nav: '详情'
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/application.js